import { JournalRole } from '@cpce/database/enums';
import z from 'zod';
export const journalWithRelations = {
    include: {
        financialAccounts: {
            where: { deletedAt: null },
            orderBy: { code: 'asc' },
            include: { supplierPayable: { select: { name: true } } },
        },
    },
};
export const journalDataSchema = z.object({
    code: z.string().trim().min(1, 'Le code est requis'),
    name: z.string().trim().min(1, 'Le nom est requis'),
    role: z.enum(JournalRole).nullable().default(null),
    isArchived: z.boolean().default(false),
});
// The treasury accounts (classe 5) whose automatic écritures — règlements, remises, rejets,
// virements internes — post to this journal. Set as a whole from the journals list.
export const journalTreasuryAccountsSchema = z.object({
    financialAccountIds: z.array(z.number().int().positive()),
});
export const isTreasuryAccountCode = (code) => code.startsWith('5');
